import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Cookie } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { Button } from "@/components/ui/button";

export const CookieBanner = () => {
  const { t } = useLang();
  const location = useLocation();
  const [visible, setVisible] = useState(() => !localStorage.getItem("snetch_cookie_ok"));

  // Never overlay the in-match gameplay controls (fixed bottom bar would cover position cards on mobile).
  if (!visible || location.pathname.startsWith("/match")) return null;

  const accept = () => {
    localStorage.setItem("snetch_cookie_ok", "1");
    setVisible(false);
  };

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-[60] border-t border-white/10 bg-panel/95 backdrop-blur-md"
    >
      <div className="max-w-5xl mx-auto px-4 py-2.5 sm:py-4 flex flex-row items-center gap-3">
        <Cookie className="w-5 h-5 text-signal shrink-0 hidden sm:block" />
        <p className="font-mono text-[11px] text-white/60 leading-snug flex-1">
          {t("cookie_msg")}{" "}
          <Link to="/privacy" data-testid="cookie-privacy-link" className="text-signal hover:text-white underline underline-offset-2">
            {t("cookie_more")}
          </Link>
        </p>
        <Button
          data-testid="cookie-accept"
          onClick={accept}
          size="sm"
          className="bg-signal text-black hover:bg-white rounded-sm font-semibold whitespace-nowrap shrink-0"
        >
          {t("cookie_accept")}
        </Button>
      </div>
    </div>
  );
};
